import { useState } from 'react'
import { X } from 'lucide-react'
import { useAuth } from '@/hooks/use-auth'
import { CURRENT_CLIENT } from '@/constants'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import {
  dismissOnboardingCelebration,
  isOnboardingCelebrationDismissed,
} from '@/lib/onboarding-display'

interface OnboardingCompleteCardProps {
  groupName: string
  className?: string
}

export function OnboardingCompleteCard({ groupName, className }: OnboardingCompleteCardProps) {
  const { user } = useAuth()
  const email = user?.email ?? ''
  const clientName = CURRENT_CLIENT.name || 'Yes Human'
  const [dismissed, setDismissed] = useState(() =>
    email ? isOnboardingCelebrationDismissed(email, groupName) : false,
  )

  if (!email || dismissed) {
    return null
  }

  const handleDismiss = () => {
    dismissOnboardingCelebration(email, groupName)
    setDismissed(true)
  }

  return (
    <Card className={cn('shadow-sm', className)}>
      <CardHeader>
        <div className="flex items-center justify-between gap-3">
          <CardTitle className="text-2xl">Onboarding Complete!</CardTitle>
          <Button variant="ghost" size="icon" onClick={handleDismiss} aria-label="Dismiss">
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-muted-foreground">
          Congratulations! You&apos;ve completed your profile setup. You&apos;re all set to start using{' '}
          {clientName}.
        </p>
        <Button onClick={handleDismiss}>Get Started</Button>
      </CardContent>
    </Card>
  )
}
